module.exports = __webpack_public_path__ + "static/img/cooperate.650c140a.png";